import ListProcesses from "@/views/customer/quality_reports/container_provider/ListProcesses.vue";
import ShowProcess from "@/views/customer/quality_reports/container_provider/ShowProcess.vue";
import ShowProcessSummary from "@/components/views/customer/quality_reports/container_provider/show_process/Summary.vue";
import ShowProcessWeekly from "@/components/views/customer/quality_reports/container_provider/show_process/Weekly.vue";
import ShowProcessQuarterly from "@/components/views/customer/quality_reports/container_provider/show_process/Quarterly.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "cus",
  role: "quality_reports",
  permission: "container_provider",
});


export default [
  {
    path: "/cus/:customer_id/quality_reports/container_provider",
    name: routeName(""),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/cus/:customer_id/quality_reports/container_provider/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    props: true,
    meta: META,
    redirect: { name: routeName("show_process_summary") },
    children: [
    {
        path: "summary",
        name: routeName("show_process_summary"),
        alias: "",
        component: ShowProcessSummary,
        props: true
      },
      {
        path: "weekly",
        name: routeName("show_process_weekly"),
        alias: "",
        component: ShowProcessWeekly,
        props: true
      },
      {
        path: "quarterly",
        name: routeName("show_process_quarterly"),
        component: ShowProcessQuarterly,
        props: true
      },
    ],
  },
];
